import { useMemo } from 'react';
import type { ColumnType } from 'antd/es/table';
import { useTpoGenConfig } from '../../context/CustomerConfigContext';
import type { PlanRecord } from '../../types/plan';
import CELL_RENDERERS from '../cellRenderers';

const SORT_DIRECTIONS: ColumnType<PlanRecord>['sortDirections'] = ['descend', 'ascend'];

const usePlanIndexColumns = (
    selectedColumns: string[],
    sortBy: string,
    sortOrder: 'asc' | 'desc',
): ColumnType<PlanRecord>[] => {
    const { planIndexColumns } = useTpoGenConfig();
    return useMemo(() => {
        return planIndexColumns.filter((col) => selectedColumns.includes(col.key)).map(
            (col): ColumnType<PlanRecord> => ({
                title: col.label,
                dataIndex: col.dataIndex,
                key: col.key,
                width: col.width,
                align: col.align,
                sorter: col.sortable !== false,
                sortDirections: SORT_DIRECTIONS,
                sortOrder:
                    sortBy === col.dataIndex ? (sortOrder === 'asc' ? 'ascend' : 'descend') : null,
                render: CELL_RENDERERS[col.type],
            }),
        );
    }, [planIndexColumns, selectedColumns, sortBy, sortOrder]);
};

export default usePlanIndexColumns;
